<template>
  <div data-component="agent-status-item-list">
    <base-sortable-list
      class="agent-status-item-list"
      :list="statusOptions"
      :is-disabled="isDisabled"
      :is-scrollable="false"
      handle="[data-button='drag-start']"
      @update="$emit('items-order-change', $event)"
    >
      <template #item="{ props: item }">
        <div class="option">
          <or-radio
            :model-value="defaultStatusKey"
            :value="item.key"
            :disabled="isDisabled"
            @update:modelValue="$emit('default-key-change', item.key)"
          />

          <agent-status-item
            :item="item"
            :is-active="item.key === targetKey"
            :is-disabled="isDisabled"
            @click="$emit('item-click', item.key)"
          />
        </div>
      </template>
    </base-sortable-list>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue-demi';
import { OrRadioV3 as OrRadio } from '@onereach/ui-components-25';

import BaseSortableList from '@/modules/common/components/BaseSortableList.vue';
import AgentStatusItem from './AgentStatusItem.vue';
import { AgentStatus } from '@/types';

export default defineComponent({
  name: 'AgentStatusItemList',
  components: {
    AgentStatusItem,
    BaseSortableList,
    OrRadio,
  },
  props: {
    statusOptions: {
      type: Array as PropType<AgentStatus[]>,
      default: () => {},
    },
    defaultStatusKey: {
      type: String,
      default: '',
    },
    targetKey: {
      type: String,
      default: '',
    },
    isDisabled: Boolean,
  },
  emits: ['items-order-change', 'item-click', 'default-key-change'],
});
</script>

<style lang="scss" scoped>
.agent-status-item-list {
  display: flex;
  flex-direction: column;
  gap: var(--s-4);

  .option {
    display: flex;
    align-items: center;
    gap: var(--s-4);
  }

  ::v-deep {
    .base-sortable-list-item {
      &:last-child {
        margin-bottom: var(--s-6);
      }
    }
  }
}
</style>
